import type { CurrentUser, CurrentUserAssignedStation } from '@transreport/pauk-rrms-api'
import type { User } from 'oidc-client-ts'
import { create } from 'zustand'

export interface AuthState {
  user: User | null
  isAuthenticated: boolean
  currentUser: CurrentUser | null

  setAuth: (user: User) => void
  clearAuth: () => void
  setCurrentUser: (currentUser: CurrentUser) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  currentUser: null,

  setAuth: (user) =>
    set({
      user,
      isAuthenticated: !user.expired,
    }),

  clearAuth: () =>
    set({
      user: null,
      isAuthenticated: false,
      currentUser: null,
    }),

  setCurrentUser: (currentUser) => set({ currentUser }),
}))

export const selectAuthProfile = (state: AuthState) => state.user?.profile ?? null

export const selectStaffEmail = (state: AuthState) => state.user?.profile?.email ?? null

export const selectStaffName = (state: AuthState) => {
  const profile = state.user?.profile

  return profile?.name ?? profile?.preferred_username ?? profile?.email ?? profile?.sub ?? null
}

const EMPTY_STATIONS: CurrentUserAssignedStation[] = []

export const selectCurrentUserStations = (state: AuthState) =>
  state.currentUser?.stations ?? EMPTY_STATIONS
